import {cr} from 'fire-wind-water';
class Tips {
  constructor() {
    this.elem = null;
    this.child = null;
    this.recursionList = [];
    this.isShow = false;
    this.createElem();
  }

  createElem() {
    this.elem = document.getElementById('sk-weak-hint');
    if (this.elem) {
      this.elem.innerHTML = '';
      const child = document.createElement('div');
      child.className = 'weat-hint-wrap hide';
      this.elem.appendChild(child);
      this.child = this.elem.querySelector('.weat-hint-wrap');
      return;
    } else {
      if (document.body) {
        const elem = document.createElement('div');
        elem.className = 'm-sk-weak-hint';
        elem.id = 'sk-weak-hint';
        document.body.appendChild(elem);
        this.createElem();
      } else {
        setTimeout(() => {
          this.createElem();
        }, 500);
      }
    }
  }

  show(s, c) {
    this.recursionList.push([s, c || {time: 3000}]);
    this.recursion();
  }

  hide(c) {
    this.child.className = 'weat-hint-wrap hide';
    this.child.innerHTML = '';
    setTimeout(() => {
      this.elem.style.display = 'none';
      this.isShow = false;
      if (cr.isFunction(c)) {
        c();
      }
      if (this.recursionList.length > 0) {
        this.recursion();
      }
    }, 300);
  }

  recursion() {
    if (this.isShow) {
      return;
    }
    const o = this.recursionList.shift();
    if (o) {
      this.showAlert(o[0], o[1]);
    }
  }

  showAlert(s, c) {
    this.isShow = true;
    this.elem.style.display = 'block';
    setTimeout(() => {
      this.child.className = 'weat-hint-wrap';
      this.child.innerHTML = s;
    }, 10);
    setTimeout(() => {
      this.hide(c.callback);
    }, c.time + 300);
  }
}

const sktips = new Tips();
export {
  sktips
};